/**
 * Generates unique label for copied field
 */
const generateCopiedFieldLabel = (
  getTextByKey: (k: string) => string,
  label: string,
  fields: {
    fields: {
      label: string;
    };
    template: string;
  }[],
  withCopyOf: boolean = true
) => {
  const newLabel = withCopyOf ? `${getTextByKey("copy-of")} ${label}` : label;
  let inc = 0;

  while (_checkIfFieldLabelExists(newLabel + (inc ? ` ${inc}` : ""), fields)) {
    inc++;
  }
  return newLabel + (inc ? ` ${inc}` : "");
};

function _checkIfFieldLabelExists(
  label: string,
  fields: { fields: { label: string } }[]
) {
  for (let i = 0; i < fields.length; i++) {
    if (fields[i].fields.label === label) {
      return true;
    }
  }
  return false;
}

export default generateCopiedFieldLabel;
